/* eslint-disable indent */
import React from "react";
import { Header } from "../../../components/Header";
import styles from "../stylesERv2.module.scss";

export const ERHeader = ({
  logo,
  selectedYear,
  setSelectedYear,
  verEnDolares,
  setVerEnDolares,
  verChileYPeru,
  setVerChileYPeru,
  modoCombinado,
  pais,
  moneda,
  isOportunidadesLoading,
  varYTDvsYTD,
  varYTDvsYTDRegion,
  runRateParaMostrar,
  runRateAnual,
  facturacionUltimos12Meses,
  variacionFactParaMostrar,
  varYTDvsFull,
  varYTDvsFullRegion,
  ebitdaRunRateParaMostrar,
  variacionEbitdaParaMostrar,
  es2026Habilitado,
  verUltimos12Meses,
  setVerUltimos12Meses,
  monthsToShow,
  onOpenChart,
  verAcumulados,
  setVerAcumulados,
  verUnitEconomics,
  setVerUnitEconomics,
  unitEconomicsReady,
  verInversionActivos,
  setVerInversionActivos,
}) => (
  <Header
    logo={logo}
    leftContent={
      <div className={styles.headerComparativas}>
        <div className="d-flex align-items-start" style={{ gap: ".69rem", fontSize: "16.9px" }}>
          {/* Títulos */}
          <div className="text-start" style={{ minWidth: "180px" }}>
            <div
              style={
                verUltimos12Meses
                  ? { filter: "blur(4px)", opacity: 0.5, pointerEvents: "none", userSelect: "none" }
                  : undefined
              }
            >
              <strong>{verUltimos12Meses ? "Facturación LTM" : "Facturación YTD"}</strong>
            </div>
            <div>
              <strong>ARR</strong> (últimos 3 meses)
            </div>
          </div>

          {/* vs YTD + Run Rate Facturación */}
          <div className="text-start" style={{ fontSize: "16.5px", minWidth: "24rem" }}>
            <div
              style={
                verUltimos12Meses
                  ? { filter: "blur(4px)", opacity: 0.5, pointerEvents: "none", userSelect: "none" }
                  : undefined
              }
            >
              | vs YTD {selectedYear - 1}{" "}
              {(() => {
                if (isOportunidadesLoading) return <span style={{ color: "#666" }}>-</span>;
                const variacion = modoCombinado ? varYTDvsYTDRegion : varYTDvsYTD;
                if (variacion === null) return <span style={{ color: "#666" }}>—</span>;
                const color = variacion > 0 ? "#2e7d32" : variacion < 0 ? "#c62828" : "#000";
                const loc = pais === "Chile" || modoCombinado ? "es-CL" : "en-US";
                const dec = Math.abs(variacion) < 10 ? 1 : 0;
                return (
                  <strong style={{ color, fontWeight: 700 }}>
                    {variacion >= 0 ? "↑" : "↓"}{" "}
                    {Math.abs(variacion).toLocaleString(loc, {
                      minimumFractionDigits: dec,
                      maximumFractionDigits: dec,
                    })}
                    %
                  </strong>
                );
              })()}
            </div>
            <div>
              | Facturación Run Rate {modoCombinado || verEnDolares ? "US$ " : moneda(pais)}
              {runRateParaMostrar.toLocaleString(pais === "Chile" || modoCombinado ? "de-DE" : "en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
              {(() => {
                if (isOportunidadesLoading) return <span style={{ color: "#666" }}> -</span>;
                if (modoCombinado) {
                  const variacion = variacionFactParaMostrar || 0;
                  const color = variacion > 0 ? "#2e7d32" : variacion < 0 ? "#c62828" : "#000";
                  const locC = "es-CL";
                  const dec = Math.abs(variacion) < 10 ? 1 : 0;
                  return (
                    <strong style={{ color, fontWeight: 700 }}>
                      {" "}
                      {variacion >= 0 ? "↑" : "↓"}{" "}
                      {Math.abs(variacion).toLocaleString(locC, {
                        minimumFractionDigits: dec,
                        maximumFractionDigits: dec,
                      })}
                      %
                    </strong>
                  );
                }
                // Comparar Run Rate vs Facturación últimos 12 meses (ventana móvil)
                const variacion =
                  facturacionUltimos12Meses > 0 ? (runRateAnual / facturacionUltimos12Meses - 1) * 100 : 0;
                const color = variacion > 0 ? "#2e7d32" : variacion < 0 ? "#c62828" : "#000";
                const loc = pais === "Chile" ? "es-CL" : "en-US";
                const dec = Math.abs(variacion) < 10 ? 1 : 0;
                return (
                  <strong style={{ color, fontWeight: 700 }}>
                    {" "}
                    {variacion >= 0 ? "↑" : "↓"}{" "}
                    {Math.abs(variacion).toLocaleString(loc, {
                      minimumFractionDigits: dec,
                      maximumFractionDigits: dec,
                    })}
                    %
                  </strong>
                );
              })()}
            </div>
          </div>

          {/* vs AA + Run Rate EBITDA */}
          <div className="text-start" style={{ fontSize: "16.5px", minWidth: "21rem" }}>
            <div
              style={
                verUltimos12Meses
                  ? { filter: "blur(4px)", opacity: 0.5, pointerEvents: "none", userSelect: "none" }
                  : undefined
              }
            >
              | vs AA {selectedYear - 1}{" "}
              {(() => {
                if (isOportunidadesLoading) return <span style={{ color: "#666" }}>-</span>;
                const variacion = modoCombinado ? varYTDvsFullRegion : varYTDvsFull;
                if (variacion === null) return <span style={{ color: "#666" }}>—</span>;
                const color = variacion > 0 ? "#2e7d32" : variacion < 0 ? "#c62828" : "#000";
                const loc = pais === "Chile" || modoCombinado ? "es-CL" : "en-US";
                const dec = Math.abs(variacion) < 10 ? 1 : 0;
                return (
                  <strong style={{ color, fontWeight: 700 }}>
                    {variacion >= 0 ? "↑" : "↓"}{" "}
                    {Math.abs(variacion).toLocaleString(loc, {
                      minimumFractionDigits: dec,
                      maximumFractionDigits: dec,
                    })}
                    %
                  </strong>
                );
              })()}
            </div>
            <div>
              | EBITDA Run Rate {modoCombinado || verEnDolares ? "US$ " : moneda(pais)}
              {ebitdaRunRateParaMostrar.toLocaleString(pais === "Chile" || modoCombinado ? "de-DE" : "en-US", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })}
              {isOportunidadesLoading ? (
                <span style={{ color: "#666" }}> -</span>
              ) : (
                variacionEbitdaParaMostrar !== null && (
                  <strong
                    style={{
                      color: variacionEbitdaParaMostrar > 0 ? "#2e7d32" : "#c62828",
                      fontWeight: 700,
                      fontSize: "16.5px",
                    }}
                  >
                    {" "}
                    {variacionEbitdaParaMostrar > 0 ? "↑" : "↓"}{" "}
                    {Math.abs(variacionEbitdaParaMostrar).toLocaleString(
                      pais === "Chile" || modoCombinado ? "es-CL" : "en-US",
                      {
                        minimumFractionDigits: Math.abs(variacionEbitdaParaMostrar) < 10 ? 1 : 0,
                        maximumFractionDigits: Math.abs(variacionEbitdaParaMostrar) < 10 ? 1 : 0,
                      }
                    )}
                    %
                  </strong>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    }
  >
    {/* Checkboxes + Selector de año */}
    <div style={{ display: "flex", alignItems: "center", gap: "1.2rem" }}>
      {/* Grid 2x2 checkboxes — texto izq, checkbox der */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: "3px 16px",
          alignItems: "center",
        }}
      >
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontSize: "0.85rem",
            justifyContent: "flex-end",
          }}
        >
          Acumulados
          <input
            type="checkbox"
            checked={verAcumulados}
            onChange={(e) => setVerAcumulados(e.target.checked)}
            style={{ width: "14px", height: "14px", cursor: "pointer" }}
          />
        </label>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: monthsToShow >= 12 || modoCombinado ? "not-allowed" : "pointer",
            fontSize: "0.85rem",
            opacity: monthsToShow >= 12 || modoCombinado ? 0.5 : 1,
            justifyContent: "flex-end",
          }}
        >
          LTM
          <input
            type="checkbox"
            checked={verUltimos12Meses}
            onChange={(e) => {
              const nuevoValor = e.target.checked;
              setVerUltimos12Meses(nuevoValor);
              if (nuevoValor) setVerChileYPeru(false);
            }}
            disabled={monthsToShow >= 12 || modoCombinado}
            style={{
              width: "14px",
              height: "14px",
              cursor: monthsToShow >= 12 || modoCombinado ? "not-allowed" : "pointer",
            }}
          />
        </label>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: unitEconomicsReady ? "pointer" : "not-allowed",
            fontSize: "0.85rem",
            opacity: unitEconomicsReady ? 1 : 0.4,
            justifyContent: "flex-end",
          }}
        >
          Unit Economics
          <input
            type="checkbox"
            checked={verUnitEconomics}
            onChange={(e) => setVerUnitEconomics(e.target.checked)}
            disabled={!unitEconomicsReady}
            style={{
              width: "14px",
              height: "14px",
              cursor: unitEconomicsReady ? "pointer" : "not-allowed",
            }}
          />
        </label>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: verUnitEconomics ? "not-allowed" : "pointer",
            fontSize: "0.85rem",
            opacity: verUnitEconomics ? 0.4 : 1,
            justifyContent: "flex-end",
          }}
        >
          Activos
          <input
            type="checkbox"
            checked={verInversionActivos && !verUnitEconomics}
            onChange={(e) => setVerInversionActivos(e.target.checked)}
            disabled={verUnitEconomics}
            style={{ width: "14px", height: "14px", cursor: verUnitEconomics ? "not-allowed" : "pointer" }}
          />
        </label>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontSize: "0.85rem",
            justifyContent: "flex-end",
          }}
        >
          Ver en US$
          <input
            type="checkbox"
            checked={verEnDolares}
            onChange={(e) => {
              const nuevoValor = e.target.checked;
              setVerEnDolares(nuevoValor);
              if (!nuevoValor) setVerChileYPeru(false);
            }}
            style={{ width: "14px", height: "14px", cursor: "pointer" }}
          />
        </label>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: verEnDolares && !verUltimos12Meses ? "pointer" : "not-allowed",
            fontSize: "0.85rem",
            opacity: verEnDolares && !verUltimos12Meses ? 1 : 0.5,
            justifyContent: "flex-end",
          }}
        >
          {pais === "Chile" ? "Sumar Perú" : "Sumar Chile"}
          <input
            type="checkbox"
            checked={verChileYPeru}
            onChange={(e) => setVerChileYPeru(e.target.checked)}
            disabled={!verEnDolares || verUltimos12Meses}
            style={{
              width: "14px",
              height: "14px",
              cursor: verEnDolares && !verUltimos12Meses ? "pointer" : "not-allowed",
            }}
          />
        </label>
      </div>
      {/* Botón gráfico */}
      <button className="chart-btn" onClick={onOpenChart} title="Ver gráfico">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <rect x="3" y="12" width="4" height="9" rx="1" />
          <rect x="10" y="7" width="4" height="14" rx="1" />
          <rect x="17" y="3" width="4" height="18" rx="1" />
        </svg>
      </button>
      {/* Columna año */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px" }}>
        {verUltimos12Meses ? (
          <div
            style={{
              padding: "4px 8px",
              borderRadius: "5px",
              border: "1px solid #bbb",
              fontSize: "0.9rem",
              backgroundColor: "#eee",
              minWidth: "80px",
              textAlign: "center",
              color: "#999",
            }}
          >
            -
          </div>
        ) : (
          <select
            value={selectedYear}
            onChange={(e) => setSelectedYear(Number(e.target.value))}
            style={{
              padding: "4px 8px",
              borderRadius: "5px",
              border: "1px solid #bbb",
              fontSize: "0.9rem",
              backgroundColor: "#fff",
              minWidth: "80px",
            }}
          >
            <option value={2025}>2025</option>
            <option value={2026} disabled={!es2026Habilitado}>
              2026 {!es2026Habilitado}
            </option>
          </select>
        )}
      </div>
    </div>
  </Header>
);
